import script from "./remark-type-selector-button.vue?vue&type=script&setup=true&lang=js"
export * from "./remark-type-selector-button.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__